var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaf = function SvgLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9999 80C36.9762 80.0213 30.2009 77.402 25.018 72.6617C19.835 67.9213 16.623 61.4062 16.0189 54.4084C15.4147 47.4107 17.4627 40.4414 21.7565 34.883C26.0504 29.3245 32.2764 25.5828 39.1999 24.4C61.9999 20 67.9999 17.92 75.9999 8C79.9999 16 83.9999 24.72 83.9999 40C83.9999 62 64.8799 80 43.9999 80Z",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 84C8 72 15.4 62.56 28.32 60C38 58.08 48 52 52 48",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLeaf;